import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import { config } from "../config";
import enTranslation from "./locales/en.json";
import ruTranslation from "./locales/ru.json";

const i18n = createInstance();

i18n.use(initReactI18next).init({
  debug: false,
  resources: {
    en: { translation: enTranslation },
    ru: { translation: ruTranslation },
  },
  lng: config.appLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  ns: ["translation"],
  defaultNS: "translation",
});

export default i18n;
